import { RealtyCloudApi } from 'shared/api/api';

export interface ApiRiskMethods {
  AddOwner<T = any>(data: OwnerItemRequestBody[]): Promise<T>;
  UpdateOwner<T = any>(data: OwnerRequestBody): Promise<T>;
  GetReport<T = GetRiskReportResponse>(orderItemId: OrderItemID): Promise<T>;
  GetReportStatementsData<T = RiskReportStatementsResponse>(orderItemId: OrderItemID): Promise<T>;
  CreateReport<T = RiskStatusResponse>(data: RiskCreateRequestBody): Promise<T>;
  CreatePDF<T = RiskStatusResponse>(orderItemId: string): Promise<T>;
  UpdateOwnerItem<T = RiskStatusResponse>(data: RiskUpdateOwnerItemRequestBody): Promise<T>;
  RemoveOwnerItem<T = RiskStatusResponse>(data: RiskRemoveOwnerItemRequestBody): Promise<T>;
  UpdateScraperStatus<T = RiskStatusResponse>(data: UpdateScraperStatusRequestBody): Promise<T>;
  AddConclusion<T = any>(data: AddConclusionRequest): Promise<T>;
}

export function riskMethods(this: RealtyCloudApi): ApiRiskMethods {
  return {
    AddOwner: (data: OwnerItemRequestBody[]) => {
      return this.request({
        url: '/risk/owner',
        method: 'POST',
        data,
      });
    },

    UpdateOwner: (data: OwnerRequestBody) => {
      return this.request({
        url: '/risk/owner',
        method: 'PUT',
        data,
      });
    },

    GetReport: (orderItemId: OrderItemID) => {
      return this.request({
        url: `/admin/risk/report/${orderItemId}`,
      });
    },

    GetReportStatementsData: (orderItemID: OrderItemID) => {
      return this.request({ url: `/admin/risk/report/${orderItemID}/statements` });
    },

    CreateReport: (data: RiskCreateRequestBody) => {
      return this.request({
        url: '/admin/risk/report',
        method: 'POST',
        data,
      });
    },

    CreatePDF: (orderItemID: OrderItemID) => {
      return this.request({
        url: '/admin/risk/report/create_pdf',
        method: 'POST',
        params: { orderItemID },
      });
    },

    UpdateOwnerItem: (data: RiskUpdateOwnerItemRequestBody) => {
      return this.request({
        url: '/admin/risk/report/owner_item',
        method: 'PUT',
        data,
      });
    },

    // ResetReportItem: (data: ResetReportItemBody) => {
    //   return this.request({
    //     url: '/admin/risk',
    //     method: 'PUT',
    //     data,
    //   });
    // },

    RemoveOwnerItem: (data: RiskRemoveOwnerItemRequestBody) => {
      return this.request({
        url: '/admin/risk/report/owner_item',
        method: 'DELETE',
        data,
      });
    },

    AddConclusion: (data: AddConclusionRequest) => {
      return this.request({
        url: '/admin/risk/report/conclusion',
        method: 'PUT',
        data,
      });
    },

    UpdateScraperStatus: (data: UpdateScraperStatusRequestBody) => {
      return this.request({
        url: '/admin/risk/report/owner_item/status',
        method: 'PUT',
        data,
      });
    },
  };
}
